import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, BLACK_700, BLACK_900, Card, DynamicSvg, GridCol, GridContainer, GridRow, Typography, getTestId, InfoTag, isValidObject, checkIsPlatform } from '@airtel/air-design-system';
import { Pressable, View } from 'react-native';
import { getBankPartnerCardWidgetStyles } from './BankPartnerCardWidgetStyles';
var bankPartnerCardWidgetStyles = getBankPartnerCardWidgetStyles();
var isWeb = checkIsPlatform('web');
export var PartnerCard = PartnerCardProp => {
  var title = PartnerCardProp.title,
    subTitle = PartnerCardProp.subTitle,
    _PartnerCardProp$show = PartnerCardProp.showIcon,
    showIcon = _PartnerCardProp$show === void 0 ? true : _PartnerCardProp$show,
    _PartnerCardProp$avat = PartnerCardProp.avatarProps,
    avatarProps = _PartnerCardProp$avat === void 0 ? {} : _PartnerCardProp$avat,
    _PartnerCardProp$keyP = PartnerCardProp.keyPairData,
    keyPairData = _PartnerCardProp$keyP === void 0 ? [] : _PartnerCardProp$keyP,
    _PartnerCardProp$show2 = PartnerCardProp.showRightIcon,
    showRightIcon = _PartnerCardProp$show2 === void 0 ? false : _PartnerCardProp$show2,
    rightIconName = PartnerCardProp.rightIconName,
    _PartnerCardProp$keyV = PartnerCardProp.keyValueColCountDesktop,
    keyValueColCountDesktop = _PartnerCardProp$keyV === void 0 ? 2 : _PartnerCardProp$keyV,
    onCardItemPress = PartnerCardProp.onCardItemPress,
    onUserAction = PartnerCardProp.onUserAction,
    cardStyle = PartnerCardProp.cardStyle,
    id = PartnerCardProp.id,
    _PartnerCardProp$test = PartnerCardProp.testID,
    testID = _PartnerCardProp$test === void 0 ? 'BankPartnerCardWidget' : _PartnerCardProp$test,
    _PartnerCardProp$show3 = PartnerCardProp.showInfoTagOnCard,
    showInfoTagOnCard = _PartnerCardProp$show3 === void 0 ? false : _PartnerCardProp$show3,
    infoTagProps = PartnerCardProp.infoTagProps,
    cardTitleStyle = PartnerCardProp.cardTitleStyle,
    titleProps = PartnerCardProp.titleProps,
    subTitleProps = PartnerCardProp.subTitleProps;
  return _jsxs(Pressable, Object.assign({
    onPress: () => {
      onCardItemPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onCardItemPress), {
        item: PartnerCardProp
      }));
    }
  }, {
    children: [!!showInfoTagOnCard && isValidObject(infoTagProps) && _jsx(InfoTag, Object.assign({}, infoTagProps, getTestId(testID, 'Infotag'))), _jsxs(Card, Object.assign({
      style: cardStyle
    }, {
      children: [_jsxs(View, Object.assign({}, getTestId(testID), {
        style: [bankPartnerCardWidgetStyles.container, cardTitleStyle]
      }, {
        children: [_jsx(View, Object.assign({
          style: bankPartnerCardWidgetStyles.iconContainer
        }, {
          children: !!showIcon && _jsx(Avatar, Object.assign({}, avatarProps, getTestId(testID + "_{AvatarIcon}")))
        })), _jsxs(View, Object.assign({
          style: bankPartnerCardWidgetStyles.textContainer
        }, {
          children: [!!title && _jsx(Typography, Object.assign({
            type: isWeb ? 'body-para-md-bold' : 'body-para-xs-bold',
            text: title,
            color: BLACK_900
          }, titleProps)), !!subTitle && _jsx(Typography, Object.assign({
            type: isWeb ? 'body-para-md' : 'body-para-xs',
            text: subTitle,
            color: BLACK_700
          }, subTitleProps))]
        })), _jsx(View, {
          children: !!showRightIcon && _jsx(DynamicSvg, Object.assign({
            color: BLACK_700,
            iconName: rightIconName
          }, getTestId(testID + "_{RightIcon}")))
        })]
      })), _jsx(GridContainer, Object.assign({}, getTestId(testID, 'gridContainer'), {
        noMargin: true
      }, {
        children: _jsx(GridRow, Object.assign({}, getTestId(testID, 'gridRow'), {
          noMargin: true
        }, {
          children: keyPairData === null || keyPairData === void 0 ? void 0 : keyPairData.map((item, index) => {
            return _jsx(GridCol, Object.assign({
              breakpoints: {
                xs: 12,
                md: keyValueColCountDesktop == 1 ? 12 : 6
              },
              noGutter: true
            }, {
              children: _jsxs(View, Object.assign({
                style: bankPartnerCardWidgetStyles.keyValueTextContainer
              }, {
                children: [!!(item === null || item === void 0 ? void 0 : item.key) && _jsx(Typography, {
                  type: isWeb ? 'body-single-line-xs' : 'body-single-line-sm',
                  text: item === null || item === void 0 ? void 0 : item.key,
                  color: BLACK_700
                }), !!(item === null || item === void 0 ? void 0 : item.value) && _jsx(Typography, {
                  type: isWeb ? 'body-single-line-sm-bold' : 'body-single-line-md-bold',
                  text: item === null || item === void 0 ? void 0 : item.value,
                  color: (item === null || item === void 0 ? void 0 : item.textColor) || BLACK_900
                })]
              }))
            }), "single_key_" + index);
          })
        }))
      }))]
    }))]
  }));
};